// @ts-nocheck
import ApplicationState from "@insite/client-framework/Store/ApplicationState";

export const loadMailChimpIsConfigured = (state: ApplicationState) => {
    return state.store.pages.userSetup.isConfigured;
};

export const loadMailChimpMemberInfo = (state: ApplicationState) => {
    return state.store.pages.userSetup.memberInfo;
};

export const loadMailChimpResponse = (state: ApplicationState) => {
    return state.store.pages.userSetup.response;
};
